import { ConfirmDialog } from "@/components/kit";
import { aed } from "@/components/sales/shared";

interface CancelOrderModalProps {
  isOpen: boolean;
  displayId: string;
  totalAmount: number;
  onClose: () => void;
  handleCancel: () => void;
  isLoading: boolean;
}

const CancelOrderModal = ({
  isOpen,
  onClose,
  displayId,
  totalAmount,
  handleCancel,
  isLoading,
}: CancelOrderModalProps) => (
  <ConfirmDialog
    cancelLabel="Keep Order"
    confirmLabel="Cancel Order"
    isOpen={isOpen}
    isPending={isLoading}
    title={`Cancel order #${displayId}?`}
    onClose={onClose}
    onConfirm={handleCancel}
  >
    <p className="text-muted text-sm">
      This will cancel the order and notify the customer.
    </p>
    <div className="border-separator mt-4 flex items-center justify-between border-t pt-4 text-sm">
      <span className="text-muted">Order total</span>
      <span className="font-medium tabular-nums">{aed(totalAmount)}</span>
    </div>
  </ConfirmDialog>
);

export default CancelOrderModal;
